import {copyText} from "./progress"

function recordFor(policy, pct, rua) {
  const parts = ["v=DMARC1", `p=${policy}`]
  if (pct !== 100) parts.push(`pct=${pct}`)
  if (rua) parts.push(`rua=mailto:${rua}`)
  return `${parts.join("; ")};`
}

function render(root) {
  const policy = root.querySelector("[data-learn-policy][aria-pressed='true']")?.dataset.learnPolicy || "none"
  const slider = root.querySelector("[data-learn-pct]")
  const pct = Number(slider?.value || 100)
  const rua = root.querySelector("[data-learn-rua]")?.value.trim()
  const record = recordFor(policy, pct, rua)
  const output = root.querySelector("[data-learn-record]")
  if (output) output.textContent = record
  const pctLabel = root.querySelector("[data-learn-pct-value]")
  if (pctLabel) pctLabel.textContent = String(pct)
  if (slider) slider.setAttribute("aria-valuetext", `${pct} percent`)
  const pctNote = root.querySelector("[data-learn-pct-note]")
  if (pctNote) {
    pctNote.hidden = pct >= 100
    const fill = pctNote.querySelector("[data-learn-pct-fill]")
    if (fill) fill.textContent = String(pct)
  }
  root.dataset.policy = policy
  root.dataset.rua = rua ? "on" : "off"
  root.querySelectorAll("[data-learn-dest]").forEach((dest) => {
    dest.hidden = dest.dataset.learnDest !== policy
  })
  const report = root.querySelector("[data-learn-report]")
  if (report) report.hidden = !(policy === "none" && rua)
}

export function mount(root) {
  const live = root.querySelector("[data-learn-copy-status]")
  root.querySelectorAll("[data-learn-policy]").forEach((button) => {
    button.addEventListener("click", () => {
      root.querySelectorAll("[data-learn-policy]").forEach((other) => {
        other.setAttribute("aria-pressed", String(other === button))
      })
      render(root)
    })
  })
  root.querySelector("[data-learn-pct]")?.addEventListener("input", () => render(root))
  root.querySelector("[data-learn-rua]")?.addEventListener("input", () => render(root))
  root.querySelector("[data-learn-copy]")?.addEventListener("click", () => {
    copyText(root.querySelector("[data-learn-record]")?.textContent || "", live, "Copied.")
  })
  render(root)
}
